import { Button } from "react-bootstrap"
import { useNavigate } from "react-router-dom"

const Success = ({ amountInPence, timestamp, email }) => {
  const navigate = useNavigate()

  const handleReturnToDashboard = async () => {
    navigate("/")
  }

  const date = new Date(timestamp * 1000).toLocaleDateString("en-GB")

  return (
    <div
      className="mt-5 w-100 mx-auto text-center"
      style={{
        maxWidth: "400px"
      }}
    >
      <h1 className="fw-semibold text-success mb-3">Payment Successful!</h1>
      <p className=" mb-1">Thank you for your payment.</p>
      <p className="mb-1">You will receive a confirmation email shortly.</p>
      <p className="mb-4">If you don't recieve an email please check your junk/spam folder. </p>

      <div className="bg-white p-0 rounded shadow w-100 text-start">
        <div className="border-bottom p-4">
          <p className="mb-0 text-muted"><strong>Payment Details</strong></p>
        </div>
        <div className="p-4">
          <p><span className="text-muted">Payment Date: </span><strong>{date}</strong></p>
          <p><span className="text-muted">Amount Paid: </span><strong>{`£${(amountInPence / 100).toFixed(2)}`}</strong></p>
          <p className="mb-0"><span className="text-muted">Email: </span><strong>{email}</strong></p>
        </div>
      </div>

      <Button className="mt-4 py-2 rounded-3" variant="dark" onClick={handleReturnToDashboard}>
        Go to Dashboard
      </Button>
    </div>
  )
}
export default Success